/**
 * @generated SignedSource<<0de9f37854526e74aee462382decb6d4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteDemoDataInput = {
  id: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type deleteDemoDataMutation$variables = {
  input: DeleteDemoDataInput;
};
export type deleteDemoDataMutation$data = {
  readonly deleteDemoData: {
    readonly company: {
      readonly id: string;
      readonly hasDemoData: boolean | null;
    } | null;
  } | null;
};
export type deleteDemoDataMutation = {
  variables: deleteDemoDataMutation$variables;
  response: deleteDemoDataMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteDemoDataPayload",
    "kind": "LinkedField",
    "name": "deleteDemoData",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Company",
        "kind": "LinkedField",
        "name": "company",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasDemoData",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteDemoDataMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteDemoDataMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "06a62832597f47cd577d431c63749876",
    "id": null,
    "metadata": {},
    "name": "deleteDemoDataMutation",
    "operationKind": "mutation",
    "text": "mutation deleteDemoDataMutation(\n  $input: DeleteDemoDataInput!\n) {\n  deleteDemoData(input: $input) {\n    company {\n      id\n      hasDemoData\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5eb422f25119a07b290df0ac679f426a";

export default node;
